import React from "react";

function Character({ characterResource }) {
  const character = characterResource.read();
  return (
    <div>
      <section>
        <h2 className="character__name">{character.name}</h2>
        <p>
          <strong>Homeworld:</strong> {character.homeworld.name}
        </p>
      </section>
      <section>
        <strong>Films:</strong>
        <ul className="character__films-list">
          {character.films.map(film => (
            <li key={film.title}>
              <label>
                Episode {film.episodeId}: {film.title}
              </label>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default Character;
